import { TextKey } from '@mews-commander/enums';
import { Typography } from '@optimus-web/core';
import {
    CardPaymentMethodStatus,
    PaymentCardState,
    SepaDirectDebitProviderState,
    SepaPaymentMethodStatus,
} from '@mews-commander/data-access';
import { LocalizedDateFromUtc, LocalizedShortTimeFromUtc } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';

interface Props {
    createdUtc: CardPaymentMethodStatus['statusUpdatedUtc'] | SepaPaymentMethodStatus['createdUtc'];
    status: PaymentCardState | SepaDirectDebitProviderState;
}

const getDetailStatusHistoryPrimaryTextKey = (status: Props['status']) => {
    switch (status) {
        case PaymentCardState.Enabled:
        case SepaDirectDebitProviderState.Enabled:
            return TextKey.PaymentMethodStatusEnabledAtTime;
        case PaymentCardState.Disabled:
        case SepaDirectDebitProviderState.Disabled:
            return TextKey.PaymentMethodStatusDisabledAtTime;
        case PaymentCardState.Expired:
            return TextKey.PaymentMethodStatusExpiredAtTime;
        default:
            return null;
    }
};

export const DetailStatusHistoryPrimaryText = ({ createdUtc, status }: Props) => {
    const textKey = getDetailStatusHistoryPrimaryTextKey(status);

    if (!textKey) {
        return null;
    }
    return (
        <LocalizedText
            textKey={textKey}
            substitutes={{
                span: (chunks) => (
                    <Typography textStyle="bodyMediumStrong" variant="secondary" as="span">
                        {chunks}
                    </Typography>
                ),
                date: <LocalizedDateFromUtc utcString={createdUtc} />,
                time: <LocalizedShortTimeFromUtc utcString={createdUtc} />,
            }}
        />
    );
};
